import React from 'react';
import { Box, Button, CircularProgress, colors, Grid, IconButton, Stack, Tooltip, Typography, useTheme } from '@mui/material';
import { useState } from 'react';
import { fileUploadService, getFileUrl } from '../services/s3-service';
import { notify } from './notify';
import { TiUpload } from "react-icons/ti";
import { makeTxtOverFLow } from '../utils/format';
import ScrollBox from './ScrollBox';
import CloseIcon from '@mui/icons-material/Close';
import { InsertDriveFile } from '@mui/icons-material';


function AttachFileUpload({ filesArr, onUpload, onRemove, width, title, fontSize, errMsg, height, btnHeight, btnIcSize, maxHeight,
  fileWidth, inputId, needFileIc = true }) {
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const labelStyle = {
    color: errMsg ? colors.red[500] : "rgba(0, 0, 0, 0.8)",
    fontWeight: 500,
    fontSize: fontSize || 12,
    // width: labelwidth ? labelwidth : 500
  }

  async function handleFileUpload(e) {
    setLoading(true);
    const files = Array.from(e.target.files);
    try {
      const uploadedFiles = [];
      for (const file of files) {
        const fileKey = await fileUploadService(file);
        const imgUrl = await getFileUrl({ fileKey });
        uploadedFiles.push({ fileKey, fileUrl: imgUrl, fileName: file.name });
      }
      onUpload(uploadedFiles);
    } catch (error) {
      console.log(error);
      if (error === "apiError")
        notify("error", "Error in File Uploading...");
      onUpload(files.map(() => ({ fileKey: null, fileUrl: null, fileName: null })));
    }

    setLoading(false);
  }

  return (
    <Stack sx={{ width: width ? width : 500 }}>
      {/* // <Stack direction={direction} alignItems={"center"}> */}
      {title && <Typography htmlFor={title} style={labelStyle} component={'label'} >{title}</Typography>}
      <Stack direction={"row"} gap={2} width={"100%"} height={height} maxHeight={maxHeight}>
        <Box sx={{ borderColor: "red", border: 1, borderRadius: 1, height, color: "rgba(0,0,0,0.4)", pt: 0.5, maxHeight }} flex={1}>
          <ScrollBox pr={4} height={"93%"}>
            <Grid container
              direction="row"
              justifyContent="start"
              alignItems="center"
            >
              {filesArr.map((i, index) => (
                <Stack direction={"row"} alignItems={"center"} gap={1} key={index} justifyContent={"center"}
                  sx={{ height: 30, width: fileWidth ? fileWidth : 240, border: 1, borderColor: "rgba(0,0,0,0.5)", borderRadius: 4, mx: 1, mb: 1, bgcolor: "rgba(162, 214, 249, 0.18)" }} >
                  {needFileIc && < InsertDriveFile sx={{ color: "red" }} />}
                  <Stack width={140} alignItems={"center"}>
                    <Tooltip title={i.fileName}>
                      {/* <Typography sx={{ fontSize: 12, color: "rgba(0,0,0,0.8)" }} >{makeTxtOverFLow(i.fileName, 15)}</Typography> */}

                      <Typography
                          sx={{ fontSize: 12, color: "rgba(0,0,0,0.8)", cursor: "pointer", textDecoration: "underline" }}
                          component="a"
                          href={i.fileUrl}
                          download={i.fileName} // ensures file downloads instead of opening in browser
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {makeTxtOverFLow(i.fileName, 15)}
                        </Typography>
                    </Tooltip>
                  </Stack>
                  <IconButton size="small" aria-label="Remove file" onClick={() => onRemove(index)}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Stack>
              ))}
            </Grid>
          </ScrollBox>
        </Box>
        {loading ? <Box sx={{
          height: btnHeight ? btnHeight : 50, borderRadius: 1, width: 50, bgcolor: theme.palette.custom.btn, display: "flex",
          alignItems: "center", justifyContent: "center"
        }}>
          <CircularProgress size={btnIcSize ? btnIcSize : 30} sx={{ color: "white" }} />
        </Box> : <label htmlFor={inputId}>
          <Button variant="contained" component="span"
            sx={{ bgcolor: theme.palette.custom.btn, height: btnHeight ? btnHeight : 50, color: "white", display: "flex", alignItems: "center", gap: 1, }}>
            <TiUpload size={btnIcSize ? btnIcSize : 30} />
          </Button>
          <input id={inputId} type="file" multiple hidden onChange={handleFileUpload} />
        </label>}
      </Stack>

    </Stack>
  );
}

export default AttachFileUpload;